let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("khIIk")).then(() => parcelRequire('dj17F'));